import { Modality } from '~/domain/dicom/modality';

/**
 * Background value for output voxels that sample outside the source
 * volume. CT is Hounsfield Units, where -1024 is the conventional
 * out-of-field floor (air itself is -1000); everything else defaults to 0.
 *
 * This is a fill value, not an eligibility check — no modality is refused
 * here (see {@link reformatBlockedReason} for the one that is).
 */
export function getModalityBackgroundValue(modality: Modality): number {
    switch (modality) {
        case Modality.CT:
            return -1024;
        default:
            return 0;
    }
}
